import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import OrganisationInvites from '@/app/dashboard/org-settings/invites';

export default function TeamManagementInvites() {
  const navigate = useNavigate();

  // This component simply acts as a wrapper to maintain backward compatibility
  // and provide a clean URL structure for team management invites
  return <OrganisationInvites />;
}
